module.exports = __webpack_public_path__ + "img/New-Logo-ShopDD-EN-1.svg";